import { render, staticRenderFns } from "./AddressRequirements.vue?vue&type=template&id=28c6c7ad&scoped=true&lang=pug&"
import script from "./AddressRequirements.vue?vue&type=script&lang=ts&"
export * from "./AddressRequirements.vue?vue&type=script&lang=ts&"
import style0 from "./AddressRequirements.vue?vue&type=style&index=0&id=28c6c7ad&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6c7ad",
  null
  
)

export default component.exports